import { useEffect, useState } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { ShareChannel } from '#src/app/shared/hooks/share';

export type ChannelEventProps = Readonly<{
	available_contexts: readonly string[];

	show_copylink: boolean;
	show_email: boolean;
	show_embed: false; // deprecated
	show_facebook: boolean;
	show_facebook_message: boolean;
	show_line: boolean;
	show_sms: boolean;
	show_twitter: boolean;
	show_vk: boolean;
	show_whatsapp: boolean;
	show_instagram: boolean;
}>;

type UseTrackShareActionsViewArgs = { channels: ShareChannel[]; petitionId: string };
export function useTrackShareActionsView({ channels, petitionId }: UseTrackShareActionsViewArgs): void {
	const track = useTracking();

	const [tracked, setTracked] = useState(false);

	useEffect(() => {
		if (tracked) return;

		void track('share_petition_view', {
			petition_id: `petition_${petitionId}`,
			source_location: 'petition_dashboard_share_modal',
			view_context: 'petition_dashboard_share_modal',
			available_contexts: channels,
			show_copylink: channels.includes('copy'),
			show_email: channels.includes('email'),
			show_embed: false, // deprecated
			show_facebook: channels.includes('facebook'),
			show_facebook_message: channels.includes('facebookMessenger'),
			show_line: channels.includes('line'),
			show_sms: channels.includes('sms'),
			show_twitter: channels.includes('twitter'),
			show_vk: false, // currently unsupported
			show_whatsapp: channels.includes('whatsapp'),
			show_instagram: channels.includes('instagram'),
		});

		// eslint-disable-next-line react-hooks/set-state-in-effect
		setTracked(true);
	}, [channels, tracked, track, petitionId]);
}
